import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="px-4 md:px-6 py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-grid-line text-xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            分类浏览
          </h2>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const isActive = location.pathname === `/category/${cat.slug}`;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl transition-all duration-300 cursor-pointer group ${
                  isActive
                    ? 'bg-primary-50 border-2 border-primary-200'
                    : 'bg-background-100 hover:bg-background-200 border-2 border-transparent'
                }`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full transition-all duration-300 ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600 group-hover:bg-accent-500 group-hover:text-background-50'
                }`}>
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? 'text-primary-600' : 'text-foreground-700 group-hover:text-foreground-900'
                }`}>
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}